import type { DBGame } from '@lykkehjulet/db-model';
import SpinProvider from './SpinProvider';
import FormalSpinProvider from './FormalSpinProvider';
import StandardSpinProvider from './StandardSpinProvider';
import FunSpinProvider from './FunSpinProvider';
import CrazySpinProvider from './CrazySpinProvider';
import CrazySoleaSpinProvider from './CrazySoleaSpinProvider';

export default class SpinProviderFactory {
  static getSpinSpeedMs(spinSpeed?: number): number {
    switch (Number(spinSpeed)) {
      case 1:
        return 6_000;
      case 2:
        return 6_000;
      case 3:
        return 6_000;
      case 4:
        return 6_000;
      case 5:
        return 6_000;
      default:
        return 6_000;
    }
  }

  static create(game: DBGame): SpinProvider {
    const spinSpeedMs = SpinProviderFactory.getSpinSpeedMs(game?.spinSpeed);

    switch (game.randomness) {
      case 1:
        return new FormalSpinProvider(spinSpeedMs);
      case 2:
        return new StandardSpinProvider(spinSpeedMs);
      case 3:
        return new FunSpinProvider(spinSpeedMs);
      case 4:
        return new CrazySpinProvider(spinSpeedMs);
      case 5:
        return new CrazySoleaSpinProvider(spinSpeedMs);
      default:
        return new FunSpinProvider(spinSpeedMs);
    }
  }
}
